module.exports = __webpack_public_path__ + "static/media/ic_wap_1.ed0db5d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/activitySu/ic_wap_1.svg
// module id = 246
// module chunks = 0